import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  flex-direction: row;
  flex-wrap: wrap;
`;
